import Signup03 from '../components/signuppage/Signup03';

const Signup03Page = () => {
    return (
        <>
            <Signup03 />
        </>
    );
};

export default Signup03Page;
